import axios from 'axios'
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';


axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    //   config.baseURL = 'http://127.0.0.1:8000/api';
    //   config.baseURL = 'http://192.168.1.117:8000/api';
    //         config.baseURL = 'http://192.168.110.247:8000/api';
    //     config.baseURL = 'http://79.175.151.22:8000/api';
    // config.baseURL = 'http://127.0.0.1:8000/api';
    // config.baseURL = 'http://79.175.151.22:7977/api';
    // config.baseURL = 'http://31.14.117.187:7977/api';
    config.baseURL = 'https://club.mihmansho.com/api';
    // config.baseURL = 'http://192.168.110.249:8000/api';
    //       config.baseURL = '/api';
     config.headers = {'Authorization': localStorage.getItem('user_id')};
    //  config.headers = {'Authorization': 'Token b36a4a2213cd145784ff613bd3822b9b482fd01b'};
    //   config.headers = {'Authorization': 'Token cb821e4f482b4e4d0d9f659f971cefc5893dfdf7'};
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    debugger;
    // if (response.data.detail === 'Invalid token.') {
    //        localStorage.setItem('user_id', '');
    //     store.dispatch(userSignOut());
    //     window.location.reload();
    //     //  this.history.push('/signin');
    //     return;
    // }

    debugger;
    return response;
}, function (error) {
    debugger;


    if (error.response.status === 401) {
        // store.dispatch(userSignOut());
        // localStorage.setItem('user_id','');
        // this.history.push('/signin');
        // this.props.history.push('/some/path');
        //   return ( <Redirect to={'/signin'}/> );
        // const errorDispatcher = useErrorDispatcher();
        // errorDispatcher('sad');


        //ok
        // const store = configureStore();
        // store.dispatch(userSignOut());
        localStorage.setItem('user_id', '');
        return;
    }
    if (error.response.status === 500) {
        // alert('خطای سرور');
        // const MySwal = withReactContent(Swal);
        // MySwal.fire({
        //     icon: 'error',
        //     title: 'خطا', showCancelButton: false,
        //     showConfirmButton: true,
        //     confirmButtonText: 'باشه',
        //     text: 'خطای سرور!',
        // });
    }

    if (error.response.status === 400) {

        // const MySwal = withReactContent(Swal);
        // MySwal.fire({
        //             icon: 'error',
        //             title: 'خطا', showCancelButton: false,
        //             showConfirmButton: true,
        //             confirmButtonText: 'باشه',
        //             text: error.response.data.errorDescription,
        //         });
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
                icon: 'error',
                title: error.response.data.errorDescription
            })
            return;



    }


    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});



export const GetPrize = (pagenumber,pagesize,q) => {

    return axios.get('/getprize',{params: {pagenumber: pagenumber,pagesize:pagesize,q:q}})
};


export const GetMyPrize = (pagenumber,pagesize,q) => {

    return axios.get('/getmyprize',{params: {pagenumber: pagenumber,pagesize:pagesize,q:q}})
};





export const GetOrder = (pagenumber,pagesize,q) => {

    return axios.get('/getorder',{params: {pagenumber: pagenumber,pagesize:pagesize,q:q}})
};


export const GetCredit = () => {

    return axios.get('/getcredit')
};

export const GetPlane = () => {
    return axios.get('/getplane')
};

export const CheckToken = () => {

    return axios.get('/checktoken')
};



export const GetPrizeDetails = (data) => {
    debugger;
    return axios.post('/getprizedetails', data)
};

export const GetPlaneDetails = (data) => {
    debugger;
    return axios.post('/getplanedetails', data)
};

export const OkPrize = (data) => {
    debugger;
    return axios.post('/okprize', data)
};


export const BuyPlane = (data) => {
    debugger;
    return axios.post('/buyplane', data)
};





export const LoginView = (data) => {
    debugger;
    return axios.post('/login', data)
};



export const LoginWithCodeView = (data) => {
    debugger;
    return axios.post('/loginwithcode', data)
};



export const defaultimage = (address) => {

    // return 'http://127.0.0.1:8000'+address;
    // return 'http://79.175.151.22:7977'+address;
    return 'https://club.mihmansho.com'+address;

};







